import { render, staticRenderFns } from "./PayCardImage.vue?vue&type=template&id=18e5c2f6&scoped=true&"
import script from "./PayCardImage.vue?vue&type=script&lang=ts&"
export * from "./PayCardImage.vue?vue&type=script&lang=ts&"
import style0 from "./PayCardImage.vue?vue&type=style&index=0&id=18e5c2f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5c2f6",
  null
  
)

export default component.exports